const NC8_BASE = process.env.REACT_APP_API_BASE_URL_NC8 || "https://nc8.olharfixo.com.br";
const INT_BASE = process.env.REACT_APP_API_BASE_URL_INT || "https://int.olharfixo.com.br";
const PROTOCOLS_ALERTS_BASE = process.env.REACT_APP_API_PROTOCOLS_BASE_URL || `${NC8_BASE}/Protocols/api/v3`;

export const API_URLS = {
  AUTH: `${NC8_BASE}/Auth/api`,
  VEHICLE: `${NC8_BASE}/Vehicles/api/v3/vehicles`,
  VEHICLE_V3: `${NC8_BASE}/Vehicles/api/v3`,
  VEHICLE_V3_NEW: `${NC8_BASE}/Vehicle/api/v3`,
  VEHICLE_RADAR: `${NC8_BASE}/Vehicle/api/v3/vehicles`,
  MAINTENANCES: `${NC8_BASE}/Maintenance/api/v3/maintenances`,
  CUSTOMERS: `${NC8_BASE}/Customer/api/v3`,
  DRIVERS: `${NC8_BASE}/Drivers/api/v3`,
  MARKERS: `${NC8_BASE}/Markers/api/v3/markers`,
  MESSAGES: `${NC8_BASE}/Vehicles/api/v3/Messages`,
  LOG: `${NC8_BASE}/Log/api/v3`,
  LICENSED: `${NC8_BASE}/Licensed/api/v3`,
  REPORTS: `${NC8_BASE}/Reports/api/v3`,
  EQUIPMENT: `${NC8_BASE}/Equipment/api/v3/manufacturer`,
  ACCREDITED: `${NC8_BASE}/Accredited/api/v3/accredited`,
  OPERATIONS: `${NC8_BASE}/Vehicle/api/v3/vehicles/operations`,
  ROUTES: `${NC8_BASE}/Vehicle/api/v3/vehicles/routes`,
  ROUTE_PLANNING: `${NC8_BASE}/Vehicle/api/v3/vehicles/route-planning`,
  CHIP: `${NC8_BASE}/Chips/api`,
  MENUS: `${NC8_BASE}/Menus/api/v3`,
  GROUPS: `${NC8_BASE}/Groups/api/v3/groups`,
  FUELS: `${NC8_BASE}/fuels/api/v3`,
  TRANSPORTS: `${NC8_BASE}/Transport/api/v3/transports`,

  SCHEDULE: `${INT_BASE}/scheduleFiles/api`,
  LOGS_CONTROL: `${INT_BASE}/LogRegister/api`,
  CLIENT: `${INT_BASE}/client/api`,

  PROTOCOL_ALERTS: `${PROTOCOLS_ALERTS_BASE}/protocols/alerts`,
  PROTOCOL_ALERTS_DETAILS: `${PROTOCOLS_ALERTS_BASE}/protocols/details`,
  PROTOCOL_ALERTS_STATUS: `${PROTOCOLS_ALERTS_BASE}/protocols/status`,
  PROTOCOL_STATUS_BASE: `${PROTOCOLS_ALERTS_BASE}/protocols`,
  PROTOCOL_TYPES: `${PROTOCOLS_ALERTS_BASE}/protocols/types`,
  PROTOCOL_SUBTYPES: `${PROTOCOLS_ALERTS_BASE}/protocols/subtypes`,
  PROTOCOL_REMINDER: `${PROTOCOLS_ALERTS_BASE}/protocols/remember`,
  PROTOCOL_SUMMARY: `${PROTOCOLS_ALERTS_BASE}/protocols/summary`,
};
